import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { ErrorHandler, captureException } from '@playbookux/playbook-web-core';

import { handleMoveDraftUpdate } from '../../graphql';
import { CHANGE_PROJECT_STATUS } from '../invite-testers/graphql';
import {
  Modal,
  ContainerButton,
  ButtonCancel,
  ButtonConfirm,
  Text,
  Content,
  TextError,
} from './styles';

const ModalMoveDraft = (props) => {
  const {
    projectId,
    onClose,
    size,
    refetch,
  } = props;

  const [
    changeProjectStatus,
    { loading, error },
  ] = useMutation(CHANGE_PROJECT_STATUS, {
    update: handleMoveDraftUpdate,
    onCompleted: refetch,
  });

  const handleSubmit = async () => {
    try {
      await changeProjectStatus({
        variables: {
          projectId,
          status: 'draft',
        },
      });
      onClose();
    } catch (err) {
      captureException('CHANGE_PROJECT_STATUS_FAILED', err);
    }
  };

  return (
    <Modal
      open
      onClose={onClose}
      size={size}
    >
      <Content>
        <Text>Do you want to move to draft?</Text>

        {error && (
          <TextError>
            <ErrorHandler
              error={error}
              defaultMessage="Something went wrong while moving."
            />
          </TextError>
        )}

        <ContainerButton>
          <ButtonCancel
            onClick={onClose}
            disabled={loading}
          >
            No
          </ButtonCancel>
          <ButtonConfirm
            loading={loading}
            onClick={handleSubmit}
          >
            Yes, move
          </ButtonConfirm>
        </ContainerButton>
      </Content>
    </Modal>
  );
};

ModalMoveDraft.propTypes = {
  projectId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  size: PropTypes.string,
  refetch: PropTypes.func.isRequired,
};

ModalMoveDraft.defaultProps = {
  size: 'mini',
};

export default ModalMoveDraft;
